<section class="ms-bg-modal 111">
    <!-- <h4 class="t-main-b">{{this.klData?.name}}</h4> -->

    <div class="bg-white" *ngIf="this.requestData && this.requestData.status == 'REJECTED'">
        <p class="p-head">{{'the reason of refuse' | translator}}</p>
        <span [innerHTML]="this.requestData.reason"></span>
    </div>



    <span>
        <div class="row mb-3">
            <div class="col-md-6 col-12">
                <div>
                    <input type="text" [disabled]="!editData" [(ngModel)]="klData.name" pInputText
                        class="w-100 edit-inpt">
                </div>
                <div class="d-flex justify-content-start my-2">
                    <p-fileUpload class="v4-calander my-2" *ngIf="editData" mode="basic" name="file"
                        [url]="apilink+'file/data'" [auto]="true" [chooseLabel]="'Add image' | translator"
                        accept="image/*" [maxFileSize]="1000000"
                        (onUpload)="klData.image = $event.originalEvent.body.data"></p-fileUpload>
                </div>
            </div>
            <div class="col-md-6 col-12">
                <div class="description-box-2">
                    <div class="w-100 d-flex justify-content-center">
                        <img *ngIf="klData?.image" class="img-code" [src]="staticURL+klData?.image">
                        <img *ngIf="!klData?.image" class="img-code" src="../../../../assets/icons/SBC/default-img.jpg"
                            alt="loading">
                    </div>

                </div>
            </div>
        </div>


        <p *ngIf="(this.klData?.name == '' || !this.klData?.name )">{{'Name Required' | translator}}</p>
        <p-editor *ngIf="editData" [(ngModel)]="klData.description" [style]="{ height: '320px' }"></p-editor>
        <span *ngIf="!editData" [innerHTML]="klData?.description"></span>
        <div class="row my-3">
            <div class="col-md-5">
                <div class="white-border" *ngFor="let item of material;let i = index" (click)="select(item,i)"
                    [class.selected]="item?.name + item?.link+i == selected?.name + selected?.link + selected?.index">


                    <div class="d-flex flex-wrap justify-content-between">
                        <div class="d-flex">
                            <div class="train-ms-grey-inner-box-numm">{{i+1}}</div>
                            <div class="train-ms-grey-inner-box mx-2">{{item?.name}}</div>
                        </div>
                        <div class="d-flex align-items-end mb-1" *ngIf="editData">
                            <i class="fa-solid fa-arrow-up ms-icone-modal mx-1" [hidden]="i == 0"
                                (click)="moveUp(i)"></i>
                            <i class="fa-solid fa-arrow-down ms-icone-modal mx-1" [hidden]="i == material.length - 1 "
                                (click)="moveDown(i)"></i>
                            <button class="ms-btn-modal mx-1" (click)="deleteResource(i)">{{"delete" |
                                translator}}</button>
                        </div>
                    </div>
                    <div class="train-ms-grey-inner-box">{{item?.link}}</div>
                </div>


                <div class="col-lg-12" *ngIf="editData">
                    <label class="block text-900 font-medium mb-2 font-bold mt-4" for="fileName">{{"file name"|
                        translator}}</label>
                    <div class="w-100">
                        <input class="edit-inpt-white w-100 mb-1" type="text" (change)="nameChange(fileName.value)"
                            placeholder='{{"Please write the file name"| translator}}' #fileName pInputText>
                    </div>
                    <div class="w-100 mt-4">
                        <input class="form-control edit-inpt-white-select" type="file" id="formFile"
                            (input)="addFiles($event,fileName.value)"
                            accept=".jpg,.jpeg,.png,.mp4,.pdf,.doc,.docx,.txt,.pptx,.ppt,.xlsx,.xls,video/*">
                    </div>
                    <div class="w-100 mt-2" *ngIf="fileProgress">
                        <p-progressBar [value]="uploadProgress"></p-progressBar>
                    </div>
                </div>

            </div>
            <div class="col-md-7">
                <section class="course-boxx custom-bg-1">
                    <div class="course-title">
                        <section *ngIf="!editName">
                            <div class="d-flex my-3 align-items-center">
                                <button *ngIf="editData" class="ms-btn-onclick mx-2" (click)="edit(nameUpdate)">{{'Edit'
                                    | translator}}</button>
                                <a *ngIf="!selected?.link?.includes('.pdf')" class="tag edit-inpt w-100"
                                    [href]="staticURL+selected?.link" target="_blank">
                                    {{selected?.name}}
                                </a>
                                <a *ngIf="selected?.link?.includes('.pdf')" class="tag edit-inpt w-100">
                                    {{selected?.name}}
                                </a>
                            </div>
                        </section>
                        <section *ngIf="editName">
                            <div class="d-flex my-3 align-items-center">
                                <!-- (change)="nameChange()" -->
                                <div class="w-100">
                                    <input type="text" [(ngModel)]="nameUpdate"
                                        placeholder='{{"Please write the file name"| translator}}' pInputText
                                        class="w-100 edit-inpt">
                                </div>
                                <div>
                                    <button class="ms-btn-onclick mx-2" (click)="edit(nameUpdate)">{{'Update'|
                                        translator}}</button>
                                </div>
                            </div>

                        </section>

                        <div *ngIf="selected?.link?.includes('.pdf')" class="w-100 h-100">
                            <object [data]="showPdf()" type="application/pdf" style="width: 100%; height: 80vh; display: block;
                                                border-top: #525659 solid 5px; border-bottom: #525659 solid 5px;">
                                <a [href]="staticURL+selected?.link">
                                    {{"Download file.pdf" | translator}}
                                </a>
                            </object>
                        </div>
                        <div class=" d-flex justify-content-center" *ngIf="selected?.link">

                            <img *ngIf="selected?.link?.includes('.png') || selected?.link?.includes('.jpg') || selected?.link?.includes('.jpeg')"
                                class="course-img" alt="unable to view" [src]="selected?.link">

                            <video [src]="selected?.link" type="video/mp4"
                                *ngIf="selected?.link?.includes('http') && !selected?.link?.includes('www.youtube.com') && selected?.link?.includes('.mp4') || selected?.link?.includes('.m4v') || selected?.link?.includes('.webm') || selected?.link?.includes('.wmv') || selected?.link?.includes('.mov') || selected?.link?.includes('.mkv')"
                                class="w-100" border-radius="8px" width="640" height="360" controls>
                                {{"Your browser does not support this type of video"| translator}}
                            </video>

                            <div *ngIf="selected?.link?.includes('www.youtube.com')" class="w-100 you-player">
                                <youtube-player [videoId]="idView" (ready)="savePlayer($event)">
                                </youtube-player>
                            </div>

                            <a *ngIf="!showPDF && selected?.link?.includes('.pdf')" [href]="staticURL+selected?.link"
                                target="_blank" class="tag">
                                <object [data]="selected?.link" type="application/pdf" style="width: 100%; height: 65vh; display: block;
                                            border-top: #525659 solid 5px; border-bottom: #525659 solid 5px;">
                                    <a target="_blank" [href]="selected?.link">{{"Download file" | translator}}</a>
                                </object>
                            </a>


                            <a *ngIf="selected?.link?.includes('.doc') || selected?.link?.includes('.docx') || selected?.link?.includes('.txt')"
                                [href]="staticURL+selected?.link" target="_blank" class="tag">
                                <i class="pi pi-file-word excel-ui"></i>
                            </a>

                            <a *ngIf="selected?.link?.includes('.xls') || selected?.link?.includes('.xlsx')|| selected?.link?.includes('.csv')"
                                [href]="staticURL+selected?.link" target="_blank" class="tag">
                                <i class="pi pi-file-excel excel-ui"></i>
                            </a>

                            <a *ngIf="selected?.link?.includes('.ppt') || selected?.link?.includes('.pptx')"
                                [href]="staticURL+selected?.link" target="_blank" class="tag">
                                {{"this icon not"| translator}}
                                <i class="pi pi-file-word"></i>
                            </a>
                        </div>
                    </div>
                </section>
            </div>

        </div>




        <div class="d-flex justify-content-center my-3">
            <button *ngIf="!this.requestData" class="ms-btn-onclick" (click)="submit()">{{"Submit Request" |
                translator}}</button>
            <button *ngIf="this.requestData && this.requestData.status == 'PENDING'" class="ms-btn-onclick mx-2"
                (click)="approveKL()">{{"Approve" | translator}}</button>
            <button *ngIf="this.requestData && this.requestData.status == 'PENDING'" class="ms-btn-onclick red"
                (click)="rejectModal = true">{{"Reject" | translator}}</button>
        </div>
    </span>
    <app-no-data *ngIf="material.length <= 0"></app-no-data>
</section>

<p-dialog header="{{'the reason of refuse' | translator}}" [(visible)]="rejectModal" [style]="{width: '50vw'}">
    <p>
        {{'Are you sure you want to reject please state the reason below' | translator}}
    </p>
    <p-editor [(ngModel)]="reason" [style]="{'height':'320px'}"> </p-editor>
    <button class="ms-btn-onclick" (click)="rejectRequest()">{{"Reject" | translator}}</button>
    <button class="ms-btn-onclick" (click)="rejectModal = false">{{"cancel" | translator}}</button>

</p-dialog>

<p-toast></p-toast>